import React, { useState, useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
// import {ICON_COLOUR} from "../lib/constants/style_constants";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    border: "1px solid #d5d5d5",
    position: "relative",
    height: "45px",
    display: "flex",
    "& button": {
      width: "200px",
      borderRadius: 0,
      textTransform: "initial",
      "& .MuiButton-label": {
        justifyContent: "space-between",
        width: "150px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    },
  },
  popper: {
    zIndex: "1500 !important",
    width: "148px",
    transform: "translate3d(0px, -144px, 0px)",
  },
  inputBase: {
    height: "32px",
    paddingLeft: "10px",
    //adding for font and colour changes/
    fontSize: "16px",

    fontFamily: "Open Sans",
    "& input": {
      paddingTop: "22px",
    },
  },
}));

function SearchByCategory(props) {
  const classes = useStyles();
  const anchorRef = React.useRef(null);
  const [open, setOpen] = useState(false);
  const {
    options,
    setSelectedOption,
    selectedOption,
    searchText,
    handleSearchText,
    placeholder,
  } = props;
  const themeColor =
    sessionStorage.getItem("role") == "admin" ? "#3B86FF" : "#981B1E";

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleSelect = (option) => {
    setSelectedOption(option);
    setOpen(false);
  };

  return (
    <div className={classes.wrapper}>
      {options && options.length > 0 && (
        <>
          {" "}
          <Button
            disableElevation
            noWrap
            fullWidth
            ref={anchorRef}
            variant="contained"
            style={{ backgroundColor: "#EF7000", color: "#fff" }}
            endIcon={<ArrowDropDownIcon size="small" />}
            onClick={() => setOpen(true)}
          >
            {selectedOption.label || props?.defaultOption}
          </Button>
          <Popper
            className={classes.popper}
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      {props?.defaultOption ? (
                        <MenuItem
                          onClick={() =>
                            handleSelect({
                              label: props?.defaultOption,
                              value: props?.defaultOption.toLowerCase(),
                            })
                          }
                          value={props?.defaultOption}
                        >
                          <Typography variant="h2">
                            <em>{props?.defaultOption}</em>
                          </Typography>
                        </MenuItem>
                      ) : null}
                      {options.map((option) => (
                        <MenuItem onClick={() => handleSelect(option)}>
                          <Typography variant="h2">{option.label}</Typography>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </>
      )}
      <InputBase
        fullWidth
        className={classes.inputBase}
        placeholder={placeholder || "Search anything"}
        value={searchText}
        onChange={(e) => handleSearchText(e.target.value)}
        startAdornment={
          <InputAdornment position="start">
            <Typography style={{ paddingTop: "22px" }} variant="h2">
              <SearchIcon style={{ fill: "#666" }} />
            </Typography>
          </InputAdornment>
        }
      />
    </div>
  );
}

export default SearchByCategory;
